import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Endpoints } from "src/app/core/resources/endpoints";
import { environment } from "src/environments/environment";
import { Cargo } from "src/app/core/interfaces/cargo";
import { ResponseList } from "src/app/core/interfaces/response-list";

@Injectable({
    providedIn: 'root'
})
export class CargoSearchService {



    constructor(
        private _http: HttpClient,
        private _endpointResources: Endpoints
    ) { }


    getCargoByConsecutive(idCargo: String): Observable<Cargo[]> {
        return this._http.get<ResponseList<Cargo>>(
            environment.urlServerTeclogi + this._endpointResources.cargoByConsecutive + idCargo
        ).pipe(map(response => this.extractResults(response)));
    }

    getCargoByManifest(manifest: String): Observable<Cargo[]> {
        return this._http.get<ResponseList<Cargo>>(
            environment.urlServerTeclogi + this._endpointResources.cargoByManifest + manifest
        ).pipe(map(response => this.extractResults(response)));
    }

    /**
     * El endpoint `cargo?` fue migrado al formato paginado `ResponseList<Cargo>` ({ pagination, results }).
     * Se normaliza a `Cargo[]` para conservar el contrato que consumen los llamadores
     * (cargo-search y detail-vehicle) y evitar falsos "el servicio no existe".
     * Se contempla la respuesta legacy en arreglo por compatibilidad.
     */
    private extractResults(response: ResponseList<Cargo> | Cargo[]): Cargo[] {
        if (!response) return [];
        if (Array.isArray(response)) return response;
        return response.results || [];
    }


}